<h2 class="sectionTitle">{{'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.ReportTile'| translate}}</h2>
<div class="form-container">
    <h4 class="section-title">{{ 'SHARED.Search' | translate}}</h4>
    <div class="form-group">
        <label for="txtCreationDateFrom">{{ 'SHARED.DateFrom' | translate}}</label>
        <input class="form-control" id="txtCreationDateFrom" name="txtCreationDateFrom" #input="bsDatepicker"
            [(ngModel)]="creationDateFrom" bsDatepicker [minDate]='null'
            [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" placeholder="day-month-year">
     <div class="red" *ngIf="showFromDateGreaterThanTodayDateMessage">
                    {{'SHARED.REPORTS.EBOOKING_REPORT.FROM_DATE_GREATER_THAN_TODAY_DATE_MESSAGE' | translate}}
                </div>
                <div class="red" *ngIf="showFromDateGreaterThanToDateMessage">
                    {{'FRONT_USER.BIDSUPPLIERSUBSCRIPTION.FROM_DATE_GREATER_THAN_TO_DATE_MESSAGE' | translate}}
                </div>
        </div>
    <div class="form-group">
        <label for="txtCreationDateTo">{{ 'SHARED.DateTo' | translate}}</label>
        <input class="form-control" id="txtCreationDateTo" name="txtCreationDateTo" #input="bsDatepicker"
            [(ngModel)]="creationDateTo" bsDatepicker [minDate]='null'
            [bsConfig]="{dateInputFormat: 'DD-MM-YYYY'}" placeholder="day-month-year">
    </div>

</div>
<div class="btns-holder text-center">
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="loadData()"
        value="{{ 'SHARED.Search' | translate}}"  title="{{ 'SHARED.Search' | translate}}" />
    <input type="button" class="btn btn-primary SCAcustomBtn" (click)="resetData()"
        value="{{ 'SHARED.ResetSearch' | translate}}" title="{{ 'SHARED.ResetSearch' | translate}}" />
    <input type="button" class="SCAcustomBtn" *ngIf="!hideExportButton" (click)="ExportExcel()"
        value="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}" title="{{ 'SHARED.REPORTS.EXPORT_EXCEL' | translate}}"  />
</div>
<app-grid-view #BidSupplierSubscriptionList></app-grid-view>
